import { ref, computed, readonly } from 'vue'
import { defineStore } from 'pinia'
import type { BrandInfo } from '@/api/auth'

export const useBrandStore = defineStore('brand', () => {
  // 状态
  const currentBrand = ref<BrandInfo | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  // 计算属性
  const currentBrandId = computed(() => currentBrand.value?.id || 0)
  const currentBrandName = computed(() => currentBrand.value?.name || '')
  const currentBrandCode = computed(() => currentBrand.value?.brandCode || '')

  // 设置当前品牌
  const setCurrentBrand = (brand: BrandInfo) => {
    currentBrand.value = brand
    error.value = null
    // 保存到localStorage
    localStorage.setItem('currentBrand', JSON.stringify(brand))
  }

  // 清除当前品牌
  const clearCurrentBrand = () => {
    currentBrand.value = null
    error.value = null
    localStorage.removeItem('currentBrand')
  }

  // 初始化品牌状态（从本地存储恢复）
  const initBrandState = () => {
    const storedBrand = localStorage.getItem('currentBrand')
    if (storedBrand) {
      try {
        const brandData = JSON.parse(storedBrand)
        currentBrand.value = brandData
      } catch (err) {
        console.error('❌ 解析本地品牌数据失败:', err)
        localStorage.removeItem('currentBrand')
      }
    }
  }

  // 检查是否有选中的品牌
  const hasSelectedBrand = computed(() => !!currentBrand.value)

  return {
    // 状态
    currentBrand: readonly(currentBrand),
    isLoading: readonly(isLoading),
    error: readonly(error),
    
    // 计算属性
    currentBrandId,
    currentBrandName,
    currentBrandCode,
    hasSelectedBrand,
    
    // 方法
    setCurrentBrand,
    clearCurrentBrand,
    initBrandState
  }
})
